import { Observable } from 'rxjs';
import { ICategory } from 'src/app/core/models/api';

export abstract class ICategoryService {
  abstract getCategories(): Observable<Array<ICategory>>;
}
